import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import SplashScreen from "./SplashScreen";
import { ApiKeyContext } from "./ApiKeyContext";
import "./App.css";
import "./index.css";

function AppWrapper() {
  const [apiKey, setApiKey] = useState<string>("");
  const [key, setKey] = useState<string | null>(null);
  const [loadingKey, setLoadingKey] = useState(false);
  const [keyError, setKeyError] = useState<string | null>(null);
  const [splashDone, setSplashDone] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setSplashDone(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  const validateKey = async () => {
    setKeyError(null);
    setLoadingKey(true);
    try {
      const res = await fetch("https://api.openai.com/v1/models", {
        headers: { Authorization: `Bearer ${apiKey}` },
      });
      if (!res.ok) {
        const body = await res.json();
        throw new Error(body.error?.message || "Clé invalide");
      }
      setKey(apiKey);
    } catch (err: any) {
      setKeyError(err.message);
    } finally {
      setLoadingKey(false);
    }
  };

  if (!splashDone) return <SplashScreen />;

  if (!key) {
    const isProbablyKey = apiKey.startsWith("sk-") && apiKey.length > 20;

    return (
      <div className="home-background">
        <div className="home-container">
          <h1 className="title">
            <span role="img" aria-label="clé">🔑</span> Games GPT
          </h1>
          <input
            className="apiInput"
            type="password"
            placeholder="Entrez votre clé OpenAI (sk-...)"
            value={apiKey}
            onChange={(e) => {
              setApiKey(e.target.value.trim());
              setKeyError(null);
            }}
            disabled={loadingKey}
          />
          {keyError && <p className="errorText">{keyError}</p>}
          <button
            className="fullWidth"
            onClick={validateKey}
            disabled={!isProbablyKey || loadingKey}
          >
            {loadingKey ? "Vérification…" : "Valider la clé"}
          </button>
        </div>
      </div>
    );
  }

  return (
    <ApiKeyContext.Provider value={key}>
      <App />
    </ApiKeyContext.Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<AppWrapper />);
